export const HTTP_ERROR = 'HTTP_ERROR'

export const httpError = status => ({ type: HTTP_ERROR, status })
